import { render, staticRenderFns } from "./CustomerInvoiceForm.vue?vue&type=template&id=bd08bcd8"
import script from "./CustomerInvoiceForm.vue?vue&type=script&lang=js"
export * from "./CustomerInvoiceForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerInvoiceForm.vue?vue&type=style&index=0&id=bd08bcd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports